module.exports = __webpack_public_path__ + "img/image-eraser1.fcf2568f.jpg";